import EXPERT_SERVICE_TYPES from "./expertServiceTypes";

export default value => {
    const data = EXPERT_SERVICE_TYPES.find(i => i.value === value);

    return data ? data.text : "N/A";
};
